import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import home from "../assets/images/main-icons/home.png";
import creditors from "../assets/images/main-icons/creditors.png";
import activity from "../assets/images/main-icons/activity.png";
import todo from "../assets/images/home-icons/todo.png";
import accountmanager from "../assets/images/home-icons/accountmanager.png";
import journal from "../assets/images/home-icons/journal.png";
import settlements from "../assets/images/home-icons/settlements.png";
import report from "../assets/images/home-icons/report.png";
import payments from "../assets/images/home-icons/payments.png";
import tickets from "../assets/images/home-icons/tickets.png";
import advocate from "../assets/images/home-icons/advocate.png";
import paralegal from "../assets/images/home-icons/paralegal.png";
import legal from "../assets/images/home-icons/legal.png";
import offer from "../assets/images/home-icons/offer.png";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/images/logo.png";
import { FaBars, FaPowerOff } from "react-icons/fa";
import { toggle, close } from "../slice/appbarSlice";
import { getToken } from "../slice/tokenSlice";
import axios from "axios";
import { setCount } from "../slice/userSlice";

const Appbar = () => {
  const appbar = useSelector((state) => state.appbar);
  const { url, user, count } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  //
  const closeAppBar = () => {
    dispatch(close());
  };
  //
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  function logout() {
    localStorage.removeItem("sml-platform-user");
    navigate("/login", { replace: true });
  }
  const location = useLocation();
  //
  const getTodoLength = async () => {
    try {
      const token = await dispatch(getToken());
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/SML_Portal`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );
      if (res.status === 200) {
        const data = res.data.data;
        data.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key] = item[key] ?? "";
          });
        });
        const filtered = data.filter((item) => {
          return item.Client_Comments === "";
        });
        dispatch(setCount(filtered.length));
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getTodoLength();
    }
  }, [user]);
  return (
    <>
      <div className={`app-bar ${appbar === true ? "active" : ""}`}>
        <div className="logo">
          <img src={logo} alt="" />
        </div>
        <ul>
          <li className="menu-list">
            <span className="menu" onClick={() => dispatch(toggle())}>
              <FaBars />
            </span>
            <div className={`appbar-logo ${appbar === true ? "active" : ""}`}>
              <img src={logo} alt="" />
            </div>
          </li>
          <hr />
          <li>
            <NavLink to={"/"} onClick={closeAppBar}>
              <span>
                <img src={home} alt="" />
              </span>
              <span className="appbar-text">Home</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/creditors"} onClick={closeAppBar}>
              <span>
                <img src={creditors} alt="" />
              </span>
              <span className="appbar-text">Creditors</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/activity"} onClick={closeAppBar}>
              <span>
                <img src={activity} alt="" />
              </span>
              <span className="appbar-text">Service Log</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/todo"} onClick={closeAppBar}>
              <span>
                <img src={todo} alt="" />
              </span>
              <span className="appbar-text">To Do</span>
              {count !== 0 && (
                <span
                  className={`${
                    location.pathname === "/todo"
                      ? "bg-white text-primary"
                      : "bg-primary text-white"
                  } bg-gradient px-2 py-1 rounded`}
                >
                  {count}
                </span>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to={"/journal"} onClick={closeAppBar}>
              <span>
                <img src={journal} alt="" />
              </span>
              <span className="appbar-text">Journal</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/accountmanager"} onClick={closeAppBar}>
              <span>
                <img src={accountmanager} alt="" />
              </span>
              <span className="appbar-text">Account manager</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/offer_module"} onClick={closeAppBar}>
              <span>
                <img src={offer} alt="" />
              </span>
              <span className="appbar-text">Settlement Offer</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/legalnotice"} onClick={closeAppBar}>
              <span>
                <img src={legal} alt="" />
              </span>
              <span className="appbar-text">Legal Charges</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/settlements"} onClick={closeAppBar}>
              <span>
                <img src={settlements} alt="" />
              </span>
              <span className="appbar-text">Settlements</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/reportchange"} onClick={closeAppBar}>
              <span>
                <img src={report} alt="" />
              </span>
              <span className="appbar-text">Report change</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/advocatelawyers"} onClick={closeAppBar}>
              <span>
                <img src={advocate} alt="" />
              </span>
              <span className="appbar-text">Advocate Lawyers</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/paralegal"} onClick={closeAppBar}>
              <span>
                <img src={paralegal} alt="" />
              </span>
              <span className="appbar-text">Para Legal</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/payments"} onClick={closeAppBar}>
              <span>
                <img src={payments} alt="" />
              </span>
              <span className="appbar-text">Payments</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/tickets"} className="mb-0" onClick={closeAppBar}>
              <span>
                <img src={tickets} alt="" />
              </span>
              <span className="appbar-text">Tickets</span>
            </NavLink>
          </li>
        </ul>
      </div>
      {/*  */}
      <div
        className={`modal-background ${modalVisible ? "active" : ""}`}
        style={{ zIndex: "100" }}
      >
        <div className="modal-container nav-modal-container">
          <h2 className="text-center">Logout?</h2>
          <div className="d-flex align-items-center justify-content-between gap-2 mt-4">
            <button
              className="red-button"
              style={{ width: "100px" }}
              onClick={logout}
            >
              Yes
            </button>
            <button
              className="button"
              style={{ width: "100px" }}
              onClick={() => setModalVisible(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Appbar;
